import { useContext } from "react";
import { AppContext } from "../contexts";

export function userPostListHelper (uuid: string) {
  const { state, dispatch } = useContext(AppContext);
  const post = state.postList.find(post => post.uuid==uuid);
  return post;
};
